import React, { useState, useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import moment from "moment";
import { getuserInfo } from "../../store/actions/userActions";
import {
  getCalendarScheduleInfo,
  updateCalendarSchedule,
} from "../../store/actions/calendarActions";
import { AppContext } from "../../contexts/AppContext";
import { AuthContext } from "../../contexts/AuthContext";
import { errorResponseMessage } from "../../shared/const.prop";

const BlockDatesCalendar = ({}) => {
  const dispatch = useDispatch();
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);
  const { calendarScheduleInfo } = useSelector((state) => state.calendar);
  const [selected, setSelected] = useState([]);
  const [disabledDates, setDisabledDates] = useState([]);

  useEffect(() => {
    if (calendarScheduleInfo && calendarScheduleInfo?.unavailableDays) {
      const unavailableDays = calendarScheduleInfo?.unavailableDays;
      if (Array.isArray(unavailableDays)) {
        const tempArry = [];
        unavailableDays.map(({ date }) => {
          tempArry.push(new Date(date));
        });
        setDisabledDates([...tempArry]);
        setSelected([...tempArry]);
      }
    }
  }, [calendarScheduleInfo]);

  const successCallback = () => {
    dispatch(getCalendarScheduleInfo());
    appContext.updateNotificationState({
      type: "success",
      message: "Blocked dates updated successfully",
      show: true,
    });
    appContext.updateModalState();
  };

  const failureCallback = (e) => {
    if (e.response.status === 429) {
      appContext.updateNotificationState({
        show: true,
        type: "error",
        message: errorResponseMessage(e),
      });
      authContext.logout();
    }
    appContext.updateNotificationState({
      show: true,
      type: "error",
      message: e?.response?.data?.message,
    });
    appContext.updateModalState();
  };

  const handleSubmit = () => {
    if (selected?.length > 0) {
      const inputData = selected.map((item) => {
        return {
          date: moment(item)?.format("YYYY-MM-DD"),
        };
      });
      const updatedData = {
        days: calendarScheduleInfo?.scheduleDays,
        unavailable: inputData,
      };
      dispatch(
        updateCalendarSchedule({
          updatedData: updatedData || {},
          successCallback,
          failureCallback,
        })
      );
    }
  };

  return (
    <>
      <div
        style={{ display: "flex", justifyContent: "center", padding: "1rem" }}
      >
        <DayPicker
          mode="multiple"
          selected={selected}
          onSelect={setSelected}
          disabled={disabledDates}
          fromMonth={new Date(moment().year(), moment().month())}
          showOutsideDays
        />
      </div>
      <div className="modal-footer mt-2 mb-3">
        <button
          type="button"
          className="btn btn-outline-primary prime-btn"
          data-dismiss="modal"
          onClick={appContext.updateModalState}
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-outline-primary modal-btn"
          onClick={handleSubmit}
        >
          Block Dates
        </button>
      </div>
    </>
  );
};

export default BlockDatesCalendar;
